export default __webpack_public_path__ + "static/media/na-loader.0b23c2ce.svg";